import { FC } from "react";
import Modal from "@/components/modal";
import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/button";

interface InfoModalProps {
  onClose: () => void;
  title: string;
  description: string;
  buttonText?: string;
  testId?: string;
  helperText?: string;
}

const InfoModal: FC<InfoModalProps> = ({
  onClose,
  title,
  description,
  buttonText,
  testId,
  helperText,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={title}
      onClose={onClose}
      contentClassName={styles.modalContent}
      data-cy={`${testId}-modal`}>
      <p>{description}</p>
      <Button
        text={buttonText || t("ui.closeModal")}
        onClick={onClose}
        size="small"
        cta={false}
        className={styles.button}
        data-cy={`${testId}-close-button`}
      />

      {helperText && <span className={styles.helperText}>{helperText}</span>}
    </Modal>
  );
};

export default InfoModal;
